<div>
  <mat-form-field class="state-editor-mediumfield state-editor-marginright">
    <mat-label>Field</mat-label>
    <mat-select matInput [(ngModel)]="condition.PropertyName" required [disabled]="disabled" (selectionChange)="conditionFieldChanged()">
      @for (field of conditionFields; track field) {
        <mat-option [value]="field.FieldId">{{ prettifyLabel(field.FieldName) }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  <mat-form-field class="state-editor-shortfield state-editor-marginright">
    <mat-label>Operator</mat-label>
    <mat-select matInput [(ngModel)]="condition.Operator" required [disabled]="disabled">
      @for (operator of operators; track operator) {
        <mat-option [value]="operator.value">{{ operator.label }}</mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (selectedFieldType === 'list') {
    <mat-form-field class="state-editor-mediumfield state-editor-marginright">
      <mat-label>Value</mat-label>
      <mat-select matInput [(value)]="condition.ValueArray" [disabled]="disabled" multiple>
        @for (valueOption of valueOptions; track valueOption) {
          <mat-option [value]="valueOption.Value">{{ valueOption.Text }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  }

  @if (selectedFieldType === 'checkbox' || selectedFieldType === 'signoff') {
    <div class="state-editor-mediumfield state-editor-marginright">
      <mat-checkbox [(ngModel)]="condition.Value" [disabled]="disabled" aria-label="Value"></mat-checkbox>
    </div>
  }

  @if (selectedFieldType === 'text') {
    <mat-form-field class="state-editor-mediumfield state-editor-marginright">
      <mat-label>Value</mat-label>
      <input matInput [(ngModel)]="condition.Value" required [disabled]="disabled" />
    </mat-form-field>
  }

  @if (!disabled) {
    <button mat-button (click)="onDeleteButtonClick()">
      <mat-icon>delete</mat-icon>
    </button>
  }

  <br />
</div>